import { render, staticRenderFns } from "./UserDetailRelations.vue?vue&type=template&id=47aac629&"
import script from "./UserDetailRelations.vue?vue&type=script&lang=js&"
export * from "./UserDetailRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports